import Header from '../../../shared/Header';
import { useTranslation } from 'react-i18next';
import { Stack } from '../../../shared/layouts';
import Card from '../../../shared/Card';
import OverviewDetailRow from '../../../shared/OverviewDetailRow';
import AdvisorDetails from '../../../shared/AdvisorDetails';
import { currencyFormatter } from '@dnhb/formatters';
import FileAttachmentButton from '../../../shared/FileAttachmentButton';
import { periodOptionInMonths } from "../../../../utils/constants";

const convertPremiumToMonthly = (premium) => {
  const amount = premium?.amount;
  const period = premium?.period;
  if (!amount || !period || !periodOptionInMonths[period]) return null;

  const amountPerMonth = amount / periodOptionInMonths[period];
  return typeof amountPerMonth === 'number' ? amountPerMonth : null;
};

export default ({
  title,
  insurance: {
    uuid,
    description,
    sub_insurances,
    package_number,
    state,
    start_date,
    policyholder,
    advisor,
  },
  isMinDesktop,
  connectedFiles,
  externalFiles,
  onSubInsuranceClick,
}) => {
  const { t } = useTranslation();
  const packageFiles = connectedFiles?.[uuid] || [];
  const allFiles = [...packageFiles, ...(externalFiles || [])];
  const totalPremium = sub_insurances?.reduce((total, sub) => {
    const monthlyPremium = convertPremiumToMonthly(sub?.premium);
    return monthlyPremium ? total + monthlyPremium : total;
  }, 0);

  return (
    <Card fontSize={isMinDesktop ? 'm' : 's'}>
      <Stack space={isMinDesktop ? 'l' : 'm'}>
        <Header
          title={title}
          variant="section"
          fontSize={isMinDesktop ? 'l' : 's'}
        />
        {(package_number ||
          state ||
          start_date ||
          policyholder ||
          advisor ||
          description) && (
          <div>
            <b>{t('Algemene gegevens')}:</b>
            <Stack space={'none'} divider={'default'}>
              <OverviewDetailRow
                descriptor={t('Pakketnummer')}
                value={package_number}
                hideIfEmpty
              />
              <OverviewDetailRow
                descriptor={t('Status')}
                value={state}
                hideIfEmpty
              />
              <OverviewDetailRow
                descriptor={t('Startdatum')}
                value={start_date}
                hideIfEmpty
              />
              <OverviewDetailRow
                descriptor={t('Verzekeringnemer')}
                value={policyholder}
                hideIfEmpty
              />
              {typeof advisor !== 'object' && (
                <OverviewDetailRow
                  descriptor={t('Adviseur')}
                  value={advisor}
                  hideIfEmpty
                />
              )}
              <OverviewDetailRow
                descriptor={t('Omschrijving')}
                value={description}
                hideIfEmpty
              />
            </Stack>
          </div>
        )}
        {typeof advisor === 'object' && Object.keys(advisor).length > 0 && (
          <AdvisorDetails {...advisor} />
        )}
        <div>
          <b>{t('Polissen')}:</b>
          <Stack space={'none'} divider={'default'}>
            {sub_insurances?.length > 0 &&
              sub_insurances.map(
                (
                  { premium, object_description, product_name },
                  insuranceIndex
                ) => {
                  const monthlySubPremium = convertPremiumToMonthly(premium);

                  return (
                    <OverviewDetailRow
                      key={insuranceIndex}
                      descriptor={product_name}
                      value={object_description}
                      details={
                        monthlySubPremium > 0
                          ? currencyFormatter(monthlySubPremium, 2, 2)
                          : null
                      }
                      action={() => onSubInsuranceClick(insuranceIndex)}
                    />
                  );
                }
              )}
            <OverviewDetailRow
              descriptor={t('PREMIE PER MAAND')}
              value={totalPremium > 0 ? currencyFormatter(totalPremium, 2, 2) : null}
              hideIfEmpty
            />
          </Stack>
        </div>
        {allFiles?.length > 0 && (
          <div>
            <b>Document(en):</b>
            <Stack space={'s'} mt={'s'}>
              {allFiles.map(({ name, download_url }) => (
                <FileAttachmentButton
                  key={name}
                  fileName={name}
                  fileUrl={download_url}
                />
              ))}
            </Stack>
          </div>
        )}
      </Stack>
    </Card>
  );
};
